export default __webpack_public_path__ + "static/media/water-jet-cutting.42cb99d2.webp";